<template><div>

    <section class="hero is-fullheight">

    <div class="hero-body is-info"   @click="regenerate()">
        <div class="container">   
            <wordcloud
                :wordClick=dummy
                :data=cloudify(words)
                nameKey="name"
                valueKey="value" 
                ref="cloud">
            </wordcloud>
        </div>
    </div> 


       <div class="hero-head">
        <div class="container">
            <div class="tabs is-centered is-size-7">                    
                <ul>
                <li class="is-grouped"  v-for='(value, key) in 工作年限' :key='key'>   
                    <div class="control">
                        <div class="tags has-addons">
                            <span class="tag is-medium is-uppercase">{{key}}</span>
                            <span class="tag is-medium is-primary is-uppercase"> {{value}} </span>
                        </div>
                    </div>
                </li>            
                </ul>
            </div>
        </div>
    </div>     
    </section>


</div></template>

<script>
import md from "../components/mdify.vue";
import wordcloud from "../components/WordCloud.vue";

export default {
  data() {
    return {
      行业经历: ["学术研究", "工业自动化", "半导体电子", "机械制造业"],
      工作年限: {
        管理: "since 2005",
        软件: "since 1998",
        电路设计: "since 1998"
      },
      accomplishments: [
        "- 建厂并盈利，",
        "－建研发团队１０年",
        "－收购moldflow",
        "－最佳团队2011",
        "- TFS/Agile/TDD/Scrum",
        "- Modernize DevOps",
        "- IoT/I4.0"
      ]
    };
  },
  mounted() {
    this.regenerate();
    setInterval(this.regenerate, 5000);
  },
  computed: {},
  methods: {
    dummy() {},
    regenerate() {
      this.$refs.cloud.onResize();
    },
    join(items) {
      return items ? items.join(" · ") : "";
    },
    shuffle(a) {
      /**https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
       * Shuffles array in place. ES6 version
       * @param {Array} a items An array containing the items.
       */
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    cloudify(tags) {
      var temp = this.shuffle(tags.slice()).slice(30, 55); //copy to evade infinite loop, see https://github.com/vuejs/vue/issues/1153
      return temp.map(function(tag) {
        return {
          name: tag,
          value: Math.random()
        };
      });
    }
  },
  props: ["words"],

  components: {
    md,
    wordcloud
  }
};
</script>




// WEBPACK FOOTER //
// src/components/landing_cloud.vue